<template>
	<div class="booking-form__section">
		<div class="booking-form__section-wrapper">
			<oh-heading :caption="componentName" :anchor="componentKebab" :canVisible="canIIsVisible" @toggleVisibility="toggleVisibility" />

			<transition-expand>
				<form class="booking-form__section-details booking-form__credentials flex-vertical" v-if="isVisible" @submit.prevent="validateForm">
					<div class="booking-form__registration-header">
						<h2 class="heading-subtitle">
							{{ $t('fill_personal_data') }}
							<a class="link" @click="loginForm">{{ $t('auth.login') }} </a>.
						</h2>
					</div>
					<div class="booking-form__registration flex-horizontal">
						<div class="booking-form__registration-wrapper flex-vertical">
							<label class="label left-align">{{ $t('fields.name') }}</label>
							<input
								class="input form__input"
								type="text"
								name="name"
								v-model="form.name"
								:class="{ 'is-danger': form.errors.has('name') }"
							/>

							<label class="label left-align">{{ $t('fields.phone') }}</label>
							<div class="phone-input__wrapper flex-horizontal">
								<select class="b-select b-select__phone-code" name="countryCode" v-model="form.countryCode">
									<option v-bind:value="420">+420</option>
									<option v-bind:value="421">+421</option>
								</select>
								<input
									class="b-input__phone input form__input"
									type="tel"
									name="phone"
									v-model="form.phone"
									:class="{ 'is-danger': form.errors.has('phone') }"
								/>
							</div>

							<label class="label left-align">{{ $t('fields.email') }}</label>
							<input
								class="input form__input"
								type="email"
								name="email"
								value=""
								v-model="form.email"
								:class="{ 'is-danger': form.errors.has('email') }"
							/>

							<div class="b__control">
								<div class="b-row b__control-row flex-horizontal">
									<label class="b__control-line flex-horizontal">
										<input class="b__control-input" type="checkbox" name="agreement" v-model="form.agreement" />
										<span class="b__control-checkbox"></span>
										<span class="b__control-label booking-regular">
											{{ $t('agree_with') }}
										</span>
									</label>
									<a class="link b__control-link booking-regular" @click="terms">{{ $t('agree_with_conditions') }}</a>
								</div>

								<div class="b-row b__control-row flex-horizontal">
									<label class="b__control-line flex-horizontal">
										<input class="b__control-input" type="checkbox" name="register" v-model="form.register" />
										<span class="b__control-checkbox"></span>
										<span class="b__control-label booking-regular">{{ $t('want_create_account') }}</span>
									</label>
								</div>
							</div>
						</div>
					</div>

					<v-button :loading="form.busy">{{ $t('booking.book') }}</v-button>
				</form>
			</transition-expand>
		</div>
	</div>
</template>

<script>
import Form from 'vForm'
import bookingMixin from '../mixins/booking.mixin'
import loginMixin from '~/mixins/login.mixin.js'
import OhHeading from './heading'

export default {
	name: 'PersonalData',

	mixins: [bookingMixin, loginMixin],

	components: { OhHeading },

	data() {
		return {
			form: new Form({
				name: null,
				email: null,
				countryCode: 420,
				phone: null,
				register: false,
				agreement: false,
			}),
		}
	},

	methods: {
		async validateForm() {
			let { name, email, phone, agreement } = this.form

			await this.form.clear()

			if (!agreement) await this.form.errors.set('agreement', this.$t('validation.must_agree'))
			if (!name) await this.form.errors.set('name', this.$t('validation.field_is_required', [this.$t('fields.name')]))
			if (!email) await this.form.errors.set('email', this.$t('validation.field_is_required', [this.$t('fields.email')]))
			if (!phone) await this.form.errors.set('phone', this.$t('validation.field_is_required', [this.$t('fields.phone')]))

			if (!this.form.errors.any()) await this.createUser()
			else this.$notifyAllErrors(this.form.errors.all())
		},

		async createUser() {
			try {
				await this.form.post(`/bs/${this.booking.id}/user`)
				this.createBooking()
			} catch ({ response }) {
				this.$notifyAllErrors(response.data.errors)
			}
		},

		terms() {
			this.$modal('useTerms/index')
		},

		loginForm() {
			this.$modal('auth/login', {}, { close: () => this.createBooking() })
		},
	},
}
</script>
